export default __webpack_public_path__ + "static/media/portal_bg.d569d359.png";